import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import {
    ButtonGroup,
    ButtonSmall,
    Panel,
} from 'react-wot-bootstrap'

import {
    roleNames,
    permissions,
    hasPermission,
    getRank,
 } from 'utils/clan_management/roles'
import { treasuryPropTypes } from 'propTypes'

import {
    AllocateTreasuryZeroPlayersSelectedTooltip,
    AllocateTreasuryNoResourceTooltip,
    ChangeRoleZeroPlayersSelectedTooltip,
    ChangeRoleCannotChangeRoleExceptTreasurersTooltip,
    ChangeRoleCannotChangeRoleTooltip,
    RemoveMembersZeroPlayersSelectedTooltip,
    RemoveMembersCannotRemoveMembersExceptTreasurersTooltip,
    RemoveMembersCannotRemoveMembersTooltip,
} from './tooltips'

import {
    BUTTON_DIVIDE_PROFITS,
    BUTTON_CHANGE_ROLE,
    BUTTON_REMOVE_MEMBERS,
} from './translations'

import styles from './MembersControlBlock.scss'

class MembersControlBlock extends React.PureComponent {
    static propTypes = {
        currentMemberRole: PropTypes.oneOf(roleNames).isRequired,
        selectedMembersCount: PropTypes.number.isRequired,
        isSelectedMembersWithSameOrHighRole: PropTypes.bool.isRequired,

        clanTreasure: treasuryPropTypes,

        onAllocateTreasuryClick: PropTypes.func.isRequired,
        onChangeRoleClick: PropTypes.func.isRequired,
        onRemoveMembersClick: PropTypes.func.isRequired,
    }

    renderRemoveMembers(cannotControlQuartermaster) {
        if (!hasPermission(this.props.currentMemberRole, permissions.REMOVE_MEMBER)) return null

        const noSelectedMembers = this.props.selectedMembersCount === 0

        let tooltip = null
        let tooltipId = null
        if (noSelectedMembers) {
            tooltip = (<RemoveMembersZeroPlayersSelectedTooltip />)
            tooltipId = RemoveMembersZeroPlayersSelectedTooltip.id
        } else if (this.props.isSelectedMembersWithSameOrHighRole) {
            if (cannotControlQuartermaster) {
                tooltip = (<RemoveMembersCannotRemoveMembersExceptTreasurersTooltip />)
                tooltipId = RemoveMembersCannotRemoveMembersExceptTreasurersTooltip.id
            } else {
                tooltip = (<RemoveMembersCannotRemoveMembersTooltip />)
                tooltipId = RemoveMembersCannotRemoveMembersTooltip.id
            }
        }

        const classNameIcon = classNames(styles.icon, styles['icon__removeMembers'], {
            [styles.isDisabled]: this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers,
        })

        return (
            <ButtonSmall
                isDisabled={this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers}
                onClick={this.props.onRemoveMembersClick}
                tooltipId={tooltipId}
                isJustified
            >
                <div className={classNameIcon} />
                {BUTTON_REMOVE_MEMBERS}
                {tooltip}
            </ButtonSmall>
        )
    }

    renderAllocateTreasury() {
        if (!hasPermission(this.props.currentMemberRole, permissions.DIVIDE_PROFITS)) return null

        const noSelectedMembers = this.props.selectedMembersCount === 0
        const notEnoughTreasure = Object.values(this.props.clanTreasure).every(amount => amount === 0)

        let tooltip
        let tooltipId
        if (noSelectedMembers) {
            tooltip = (<AllocateTreasuryZeroPlayersSelectedTooltip />)
            tooltipId = AllocateTreasuryZeroPlayersSelectedTooltip.id
        } else if (notEnoughTreasure) {
            tooltip = (<AllocateTreasuryNoResourceTooltip />)
            tooltipId = AllocateTreasuryNoResourceTooltip.id
        }

        const classNameIcon = classNames(styles.icon, styles['icon__allocateTreasury'], {
            [styles.isDisabled]: noSelectedMembers || notEnoughTreasure,
        })

        return (
            <ButtonSmall
                isDisabled={noSelectedMembers || notEnoughTreasure}
                onClick={this.props.onAllocateTreasuryClick}
                tooltipId={tooltipId}
                isJustified
            >
                <div className={classNameIcon} />
                {BUTTON_DIVIDE_PROFITS}
                {tooltip}
            </ButtonSmall>
        )
    }

    renderChangeRole(cannotControlQuartermaster) {
        if (!hasPermission(this.props.currentMemberRole, permissions.CHANGE_ROLE)) return null

        const noSelectedMembers = this.props.selectedMembersCount === 0

        let tooltip = null
        let tooltipId = null
        if (noSelectedMembers) {
            tooltip = (<ChangeRoleZeroPlayersSelectedTooltip />)
            tooltipId = ChangeRoleZeroPlayersSelectedTooltip.id

        } else if (this.props.isSelectedMembersWithSameOrHighRole) {
            if (cannotControlQuartermaster) {
                tooltip = (<ChangeRoleCannotChangeRoleExceptTreasurersTooltip />)
                tooltipId = ChangeRoleCannotChangeRoleExceptTreasurersTooltip.id
            } else {
                tooltip = (<ChangeRoleCannotChangeRoleTooltip />)
                tooltipId = ChangeRoleCannotChangeRoleTooltip.id
            }
        }

        const classNameIcon = classNames(styles.icon, styles['icon__changeRole'], {
            [styles.isDisabled]: this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers,
        })

        return (
            <ButtonSmall
                isDisabled={this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers}
                onClick={this.props.onChangeRoleClick}
                tooltipId={tooltipId}
                isJustified
            >
                <div className={classNameIcon} />
                {BUTTON_CHANGE_ROLE}
                {tooltip}
            </ButtonSmall>
        )
    }

    render() {
        const currentMemberRank = getRank(this.props.currentMemberRole)

        const cannotControlQuartermaster = currentMemberRank < 9

        const allocateTreasury = this.renderAllocateTreasury()
        const changeRole = this.renderChangeRole(cannotControlQuartermaster)
        const removeMembers = this.renderRemoveMembers(cannotControlQuartermaster)

        return (
            <Panel>
                <div className={styles.base}>
                    <ButtonGroup>
                        {allocateTreasury}
                        {changeRole}
                        {removeMembers}
                    </ButtonGroup>
                </div>
            </Panel>
        )
    }
}

export default MembersControlBlock



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersControlBlock/MembersControlBlock.js